import moment from 'moment'
import {
  LONG_DATE_TIME_FORMAT,
  MAINTENANCE_GRID_SORT_COLUMNS,
} from './appConsts'
import { getFormattedDateTime } from '@/utilities/dates'
import {
  stringTextMatcher,
  dateStringMatcher,
} from '@/components/agGrid/AgGridHelperMethods'

export const getMaintenanceStatusValue = status => {
  const value = MAINTENANCE_GRID_SORT_COLUMNS[status]
  return value || 0
}

export const getMaintenanceGridColumns = (
  internalUser,
  airlines,
  masterModels,
) => {
  return [
    {
      field: 'issueId',
      title: 'ID',
      drill: true,
    },
    {
      field: 'statusName',
      title: 'Status',
    },
    {
      field: 'airlineName',
      title: 'Airline',
      visible: airlines.length > 1,
    },
    {
      field: 'tailNumber',
      title: 'Tail',
      drill: false,
    },
    {
      field: 'analyticDisplayName',
      title: 'Analytic',
    },
    {
      field: 'masterModelName',
      title: 'Platform',
      visible: masterModels.length > 1,
    },
    {
      field: 'ataChapter',
      title: 'ATA Chapter',
    },
    // {
    //   field: 'fmtOwnerName',
    //   title: 'ALERT OWNER (FMT)',
    // },
    {
      field: 'alertCount',
      title: 'Alert Count',
    },
    {
      field: 'alertType',
      title: 'Issue Source',
    },
    {
      field: 'lastAlertDate',
      title: 'Date Last Alert',
    },
  ]
}

export const removalsColumnDefs = [
  {
    headerName: 'Removal Date',
    field: 'removalDate',
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: dateStringMatcher,
    },
    floatingFilterComponent: 'AscAgGridDateFloatFilter',
    valueFormatter: data => getFormattedDateTime(data.value),
  },
  {
    headerName: 'Part #',
    field: 'partNumber',
    sortable: true,
    suppressMenu: true,
    width: 120,
  },
  {
    headerName: 'Part Description',
    field: 'partDescription',
    sortable: true,
    suppressMenu: true,
    width: 250,
  },
  {
    headerName: 'Serial #',
    field: 'serialNumber',
    sortable: true,
    suppressMenu: true,
    width: 135,
  },
  {
    headerName: 'Removal Type',
    field: 'removalType',
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: 'Removal Description',
    field: 'removalDescription',
    sortable: true,
    suppressMenu: true,
    width: 250,
  },
  {
    headerName: 'Removal Reason',
    field: 'removalReason',
    sortable: true,
    suppressMenu: true,
    width: 250,
  },
]

export const faultMessagesColumnDefs = [
  {
    headerName: 'Type',
    field: 'faultMessageType',
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: 'Message Code',
    field: 'faultMessageCode',
    sortable: true,
    suppressMenu: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: stringTextMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    headerName: 'Date',
    field: 'faultMessageDate',
    sortable: true,
    sort: 'desc',
    suppressMenu: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: dateStringMatcher,
    },
    floatingFilterComponent: 'AscAgGridDateFloatFilter',
    valueFormatter: data => getFormattedDateTime(data.value),
  },
]

export const phmAlertColumnDefs = [
  {
    headerName: 'Date',
    field: 'date',
    sortable: true,
    suppressMenu: true,
    valueFormatter: params => {
      return moment(params.value).format(LONG_DATE_TIME_FORMAT)
    },
    sort: 'desc',
  },
  {
    headerName: 'System',
    field: 'system',
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: 'Description',
    field: 'alert',
    sortable: true,
    suppressMenu: true,
  },
]
